module.exports = __webpack_public_path__ + "img/js_logo.f00708cb.png";